import { Link, useParams } from "react-router";
import { marketplaceService } from "../services/marketplaceService";

export function ListingDetailPage() {
  const { listingId = "lst-ozempic" } = useParams();
  const listing = marketplaceService.getListing(listingId);
  const seller = marketplaceService.getPharmacy(listing.sellerId);

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm ">
      <p className="text-xs font-black uppercase tracking-[.28em] text-slate-500">Listing detail</p>
      <h1 className="mt-3 text-5xl font-black">{listing.name} {listing.dosage}</h1>
      <p className="mt-3 text-slate-600">NDC {listing.ndc} · Lot {listing.lot} · Seller {seller?.name}</p>
      <div className="mt-8 grid gap-4 md:grid-cols-3">
        <div className="rounded-2xl bg-slate-50 p-5"><span className="block text-slate-500">Price</span><strong className="text-3xl">${listing.unitPrice.toLocaleString()}</strong></div>
        <div className="rounded-2xl bg-slate-50 p-5"><span className="block text-slate-500">Quantity</span><strong className="text-3xl">{listing.quantity}</strong></div>
        <div className="rounded-2xl bg-slate-50 p-5"><span className="block text-slate-500">Packet</span><strong className="text-3xl capitalize">{listing.packetStatus.replace("_", " ")}</strong></div>
      </div>
      <div className="mt-8 flex gap-3">
        <Link className="rounded-2xl bg-slate-950 px-7 py-3 font-black text-slate-950" to={`/checkout/${listing.id}`}>Buy now</Link>
        <Link className="rounded-2xl border border-slate-200 px-7 py-3 font-black" to="/packets">Inspect packet</Link>
      </div>
    </section>
  );
}
